// Creative Crispies product page (sections/cc-product.liquid). Gallery swipe/thumbs/dots, variant pills, quantity,
// and add to cart. The whole product form is posted to /cart/add.js so line-item properties that option apps
// (Easify, Upload-Lift) inject into the form ride along. Then the cart opens the same way the homepage does.
// The custom order product also gets the configurator (snippets/cc-custom-order.liquid): print type, shape, size,
// occasion + date, artwork file and notes, all as line item properties on the same form (multipart, so the file goes too).
(() => {
  const CC = window.CC || { routes: { cartAdd: '/cart/add', cart: '/cart' }, moneyFormat: '${{amount}}' };
  const money = (cents) => {
    const a = cents / 100, f = String(CC.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
      k === 'amount_no_decimals' ? Math.round(a).toLocaleString('en-US')
      : k === 'amount_with_comma_separator' ? a.toFixed(2).replace('.', ',')
      : k === 'amount_no_decimals_with_comma_separator' ? Math.round(a).toLocaleString('de-DE')
      : a.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const $ = (s) => root.querySelector(s), $$ = (s) => [...root.querySelectorAll(s)];
    let data = { variants: [] };
    try { data = JSON.parse(($('[data-pdp-json]') || {}).textContent || '{}'); } catch (e) {}
    const variants = data.variants || [];

    // ---------- gallery ----------
    const gt = $('[data-gal-track]');
    const slides = gt ? [...gt.children] : [];
    const gi = () => (gt && gt.clientWidth ? Math.round(gt.scrollLeft / gt.clientWidth) : 0);
    const mark = (i) => $$('[data-gi]').forEach((b) => b.classList.toggle('on', +b.dataset.gi === i));
    const go = (i, smooth = true) => {
      if (!gt) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      gt.scrollTo({ left: i * gt.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
      mark(i);
    };
    if (gt) {
      let t;
      gt.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => {
        const i = gi(); mark(i);
        slides.forEach((s, n) => { if (n !== i) { const v = s.querySelector('video'); if (v && !v.paused) v.pause(); } });
      }, 60); }, { passive: true });
      $$('[data-gi]').forEach((b) => b.addEventListener('click', () => go(+b.dataset.gi)));
      $$('[data-gstep]').forEach((b) => b.addEventListener('click', () => go(gi() + +b.dataset.gstep)));
      gt.setAttribute('tabindex', '0');
      gt.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(gi() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(gi() - 1); }
      });
      // start on the selected variant's image (when ?variant= points at one that isn't first)
      const startIdx = slides.findIndex((s) => +s.dataset.mediaId === +data.featuredMedia);
      if (startIdx > 0) requestAnimationFrame(() => go(startIdx, false));
    }
    const showMedia = (id) => {
      if (!id || !gt) return;
      const i = slides.findIndex((s) => +s.dataset.mediaId === +id);
      if (i >= 0) go(i);
    };

    // ---------- variants ----------
    const form = $('form.pdp-form');
    const idInput = $('[data-variant-input]');
    const atc = $('[data-atc]');
    const qtyIn = $('[data-qty]');
    const err = $('[data-err]');
    const opts = $$('[data-opt]');
    let current = variants.find((v) => idInput && v.id === +idInput.value) || variants[0];
    const selected = () => opts.map((o) => { const b = o.querySelector('.pdp-pill.on'); return b ? b.dataset.val : null; });

    const qty = () => Math.max(1, Math.min(999, parseInt(qtyIn && qtyIn.value, 10) || 1));
    // Bundle & Save bars (1 / 2 / 6): each sets the quantity; the % off comes from the Bundle & Save code cc-bundle-codes.js puts on the cart
    const tiers = $$('[data-tier]');
    const tierOn = () => tiers.find((b) => b.classList.contains('on'));
    // same rounding as the code at checkout: the % comes off each item, rounded down to the cent
    const each = (cents, off) => cents - Math.floor(cents * off / 100);
    let coUpdate = null;
    const renderAtc = () => {
      if (coUpdate) coUpdate();
      if (!atc) return;
      if (!current) { atc.disabled = true; atc.textContent = 'Unavailable'; return; }
      atc.disabled = !current.available;
      atc.dataset.variantId = current.id;
      const t = tierOn(), total = each(current.price, t ? +t.dataset.off : 0) * qty();
      atc.textContent = current.available ? 'Add to Cart · ' + money(total) : 'Sold Out';
    };
    const renderTiers = () => {
      if (!current) return;
      tiers.forEach((b) => {
        const q = +b.dataset.tier, full = current.price * q, per = each(current.price, +b.dataset.off), now = per * q;
        const n = b.querySelector('[data-tier-now]'), w = b.querySelector('[data-tier-was]'), p = b.querySelector('[data-tier-per]');
        if (n) n.textContent = money(now);
        if (w) w.textContent = money(full);
        if (p) p.textContent = money(per);
      });
    };
    tiers.forEach((b) => b.addEventListener('click', () => {
      tiers.forEach((x) => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (qtyIn) qtyIn.value = b.dataset.tier;
      renderAtc();
    }));

    const renderPrice = () => {
      const p = $('[data-price]'), c = $('[data-compare]'), off = $('[data-off]'), so = $('[data-soldout]');
      if (!current) { if (so) { so.hidden = false; so.textContent = 'Unavailable'; } return; }
      if (p) p.textContent = money(current.price);
      const sale = current.compare > current.price;
      if (c) { c.hidden = !sale; c.textContent = sale ? money(current.compare) : ''; }
      if (off) {
        const pct = sale ? Math.round((current.compare - current.price) * 100 / current.compare) : 0;
        off.hidden = pct < 1; off.textContent = pct + '% OFF';
      }
      if (so) { so.hidden = current.available; so.textContent = 'Sold out'; }
      const unit = $('[data-unit]');
      if (unit && opts.length) unit.textContent = 'for ' + current.options.join(' / ').toLowerCase();
    };

    // pill states: "na" = no variant with this value given the other picks, "so" = that combination is sold out,
    // disabled = no variant with this value exists at all
    const renderPills = () => {
      const sel = selected();
      opts.forEach((o, i) => {
        const val = o.querySelector('[data-opt-val]');
        if (val) val.textContent = sel[i] || '';
        o.querySelectorAll('.pdp-pill').forEach((b) => {
          const v = b.dataset.val;
          const any = variants.filter((x) => x.options[i] === v);
          const match = any.filter((x) => x.options.every((ov, j) => j === i || ov === sel[j]));
          b.disabled = !any.length;
          b.classList.toggle('na', !!any.length && !match.length);
          b.classList.toggle('so', !!match.length && !match.some((x) => x.available));
          const on = sel[i] === v;
          b.classList.toggle('on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    };

    const setVariant = (v, { media = true } = {}) => {
      current = v;
      if (v && idInput) idInput.value = v.id;
      renderPills(); renderPrice(); renderTiers(); renderAtc();
      if (err) err.hidden = true;
      if (v) {
        if (media && v.media) showMedia(v.media);
        try {
          const u = new URL(location.href); u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
        root.dispatchEvent(new CustomEvent('cc:variant-change', { bubbles: true, detail: { variant: v } }));
      }
    };

    opts.forEach((o, i) => o.addEventListener('click', (e) => {
      const b = e.target.closest('.pdp-pill');
      if (!b || b.disabled) return;
      o.querySelectorAll('.pdp-pill').forEach((x) => x.classList.toggle('on', x === b));
      const sel = selected();
      let v = variants.find((x) => x.options.every((ov, j) => ov === sel[j]));
      if (!v) {
        // jump to the closest variant that has the picked value: most other options kept, available first
        const score = (x) => x.options.reduce((s, ov, j) => s + (ov === sel[j] ? 1 : 0), 0) + (x.available ? 0.5 : 0);
        v = variants.filter((x) => x.options[i] === b.dataset.val).sort((a, c) => score(c) - score(a))[0];
        if (v) opts.forEach((oo, j) => oo.querySelectorAll('.pdp-pill').forEach((x) => x.classList.toggle('on', x.dataset.val === v.options[j])));
      }
      setVariant(v || null);
    }));
    if (opts.length) renderPills();

    // ---------- quantity ----------
    $$('[data-pq]').forEach((b) => b.addEventListener('click', () => {
      if (!qtyIn) return;
      qtyIn.value = Math.max(1, Math.min(999, qty() + +b.dataset.pq));
      renderAtc();
    }));
    if (qtyIn) {
      qtyIn.addEventListener('input', renderAtc);
      qtyIn.addEventListener('change', () => { qtyIn.value = qty(); renderAtc(); });
    }

    // ---------- custom order configurator ----------
    const co = $('[data-co-form]');
    if (co && data.custom) {
      const E = (n) => co.elements[n];
      const pick = (n) => { const r = co.querySelector('[name="' + n + '"]:checked'); return r || null; };
      const LEAD = +data.leadDays || 14;
      const day = (n) => { const d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + n); return d; };
      const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      const dateIn = $('[data-co-date]'), fileIn = $('[data-co-file]'), fname = $('[data-co-fname]');
      const picked = () => (dateIn && dateIn.value ? new Date(dateIn.value + 'T00:00') : null);
      const GI = { photo: 0, logo: 1, name: 2 }; // print type -> its sample photo in the gallery
      if (dateIn) { dateIn.min = iso(day(1)); if (!dateIn.value) dateIn.value = iso(day(LEAD)); }
      // ?print=logo|photo|name|colors picks the print type (home page sample cards link here)
      const want = new URLSearchParams(location.search).get('print');
      if (want) {
        const r = co.querySelector('[data-print="' + CSS.escape(want) + '"]');
        if (r) {
          r.checked = true;
          // jump the gallery to that sample once it has a width (again after load, in case images were still sizing)
          if (want in GI) { const jump = () => { if (gi() !== GI[want]) go(GI[want], false); }; requestAnimationFrame(jump); setTimeout(jump, 400); }
        }
      }
      const perUnit = () => { const m = current && current.options.join(' ').match(/(\d+)/); return m ? +m[1] : 0; };
      const desc = () => {
        const pr = pick('properties[Print]'), sh = pick('properties[Shape]'), d = picked();
        const w = (E('properties[Wording]') || {}).value, cl = (E('properties[Colors]') || {}).value, so = (E('properties[Shape details]') || {}).value;
        return [
          pr ? pr.value + (pr.dataset.print === 'name' && w && w.trim() ? ': ' + w.trim() : '') + (pr.dataset.print === 'colors' && cl && cl.trim() ? ': ' + cl.trim() : '') : '',
          sh ? (sh.dataset.shape === 'other' && so && so.trim() ? so.trim() + ' shape' : sh.value) : '',
          (E('properties[Occasion]') || {}).value || '',
          d ? 'Need by ' + fmt(d) : ''
        ].filter(Boolean);
      };
      coUpdate = () => {
        const pr = pick('properties[Print]'), sh = pick('properties[Shape]');
        const on = [pr && pr.dataset.print, sh && sh.dataset.shape];
        co.querySelectorAll('[data-for]').forEach((x) => {
          const show = on.includes(x.dataset.for), i = x.querySelector('input');
          x.hidden = !show; if (i) { i.disabled = !show; i.required = show; }
        });
        const q = qty(), n = perUnit(), size = current ? current.options.join(' / ') : '';
        const cnt = $('[data-co-count]');
        if (cnt) cnt.innerHTML = n ? '<b>' + (q * n) + ' treats</b>' + (q > 1 ? ' · ' + q + ' × ' + size : '') : '';
        const t = $('[data-co-sum-t]'), dd = $('[data-co-sum-d]'), pp = $('[data-co-sum-p]');
        if (t) t.textContent = (q > 1 ? q + ' × ' + size + (n ? ' · ' + q * n + ' treats' : '') : size);
        if (dd) dd.textContent = desc().join(' · ');
        if (pp && current) pp.textContent = money(current.price * q);
        const h = $('[data-co-hint]'), d = picked();
        if (h) {
          const soon = !!d && d < day(LEAD);
          h.classList.toggle('warn', soon);
          h.innerHTML = soon ? 'That\'s under ' + Math.round(LEAD / 7) + ' weeks out. Send it anyway and we\'ll tell you fast if we can make it.'
            : 'Most custom orders need about ' + Math.round(LEAD / 7) + ' weeks, so <b>' + fmt(day(LEAD)) + '</b> or later is your safest bet.';
        }
      };
      co.addEventListener('change', (e) => {
        const pr = e.target.closest('[data-print]');
        if (pr && pr.dataset.print in GI) go(GI[pr.dataset.print]);
        coUpdate();
      });
      co.addEventListener('input', coUpdate);
      if (fileIn) fileIn.addEventListener('change', () => {
        const f = fileIn.files && fileIn.files[0];
        if (fname) { fname.hidden = !f; fname.textContent = f ? f.name + ' (' + (f.size > 1e6 ? (f.size / 1e6).toFixed(1) + ' MB' : Math.max(1, Math.round(f.size / 1e3)) + ' KB') + ')' : ''; }
        if (f && f.size > 20e6 && err) { err.textContent = 'That file is over 20 MB. Try a smaller one, or send it to us after you order.'; err.hidden = false; }
      });
      // "Send a request instead": the store's contact form, with every choice written into the message
      const reqBtn = $('[data-co-reqbtn]'), reqBox = $('[data-co-reqbox]'), reqForm = $('[data-co-req]'), body = $('[data-co-body]');
      if (reqBtn && reqBox) reqBtn.addEventListener('click', () => {
        reqBox.hidden = false; reqBtn.hidden = true;
        const nm = reqBox.querySelector('[name="contact[name]"]'); if (nm) nm.focus();
      });
      if (reqForm && body) reqForm.addEventListener('submit', () => {
        const notes = (E('properties[Notes]') || {}).value || '', f = fileIn && fileIn.files && fileIn.files[0];
        const val = (n) => ((E(n) || {}).value || '').trim(), pr = pick('properties[Print]'), sh = pick('properties[Shape]'), d = picked();
        body.value = ['Custom order request',
          'Size: ' + (current ? current.options.join(' / ') : '') + ' x ' + qty() + (perUnit() ? ' (' + qty() * perUnit() + ' treats)' : ''),
          pr ? 'Print: ' + pr.value : '', pr && pr.dataset.print === 'name' && val('properties[Wording]') ? 'Wording: ' + val('properties[Wording]') : '',
          pr && pr.dataset.print === 'colors' && val('properties[Colors]') ? 'Colors: ' + val('properties[Colors]') : '',
          sh ? 'Shape: ' + (sh.dataset.shape === 'other' && val('properties[Shape details]') ? val('properties[Shape details]') : sh.value) : '',
          val('properties[Occasion]') ? 'Occasion: ' + val('properties[Occasion]') : '', d ? 'Needed by: ' + fmt(d) + ' (' + iso(d) + ')' : '',
          f ? 'Artwork: ' + f.name + ' (they will send the file by email)' : '', notes.trim() ? 'Notes: ' + notes.trim() : ''].filter(Boolean).join('\n');
      });
      if ($('[data-co-done]')) $('[data-co-done]').scrollIntoView({ block: 'center' });
      coUpdate();
    }

    // ---------- add to cart ----------
    const openCart = () => {
      if (typeof window.aovCartDrawerUpdateAndOpen === 'function') {
        try { window.aovCartDrawerUpdateAndOpen(); return; } catch (e) {}
      }
      const link = document.querySelector('[data-open-cart]');
      if (link) link.click(); else location.href = CC.routes.cart;
    };
    const syncCount = () => fetch(CC.routes.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json()).then((c) => {
        document.querySelectorAll('.cart i').forEach((i) => { i.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cc:cart-updated', { detail: c }));
      }).catch(() => {});

    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || !current.available || atc.disabled) return;
      // let option apps flag their own required fields first
      const bad = [...form.querySelectorAll('input,textarea,select')].find((f) => f.name && f.name.startsWith('properties[') && !f.checkValidity());
      if (bad) { bad.reportValidity && bad.reportValidity(); return; }
      if (qtyIn) qtyIn.value = qty();
      const label = atc.textContent;
      atc.disabled = true; atc.setAttribute('aria-busy', 'true'); atc.textContent = 'Adding…';
      if (err) err.hidden = true;
      try {
        const fd = new FormData(form);
        // one-time purchase only: never send a subscription selling plan (the Appstle widget is hidden on these pages)
        fd.delete('selling_plan');
        fd.set('id', current.id);
        fd.set('quantity', qty());
        const r = await fetch(CC.routes.cartAdd + '.js', {
          method: 'POST', body: fd, credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const res = await r.json().catch(() => ({}));
        if (!r.ok || res.status) throw new Error(res.description || res.message || 'Could not add to cart');
        atc.textContent = 'Added ✓';
        await syncCount();
        openCart();
        setTimeout(() => { atc.removeAttribute('aria-busy'); renderAtc(); }, 1200);
      } catch (ex) {
        atc.removeAttribute('aria-busy');
        atc.textContent = label; atc.disabled = false;
        if (err) { err.textContent = ex.message || 'Could not add to cart. Please try again.'; err.hidden = false; }
      }
    });
  }

  const boot = () => document.querySelectorAll('[data-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // theme editor: re-init when the section reloads
  document.addEventListener('shopify:section:load', boot);
})();
